import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocalStorage } from 'react-use';

import { useDashboard } from '@crm-framework/dashboard';
import { registryActions } from '@crm-framework/registry';
import { Button } from '@crm-framework/button';
import { useGrid } from '@crm-framework/grid';

import { getLocalStorageKey } from './utils';
import { OpenStatus } from './types';

interface IReportTotalsControlProps {
  dashboardName: string;
}

export const ReportTotalsControl: React.FC<IReportTotalsControlProps> = ({
  dashboardName,
}) => {
  const dispatch = useDispatch();
  const storageKey = getLocalStorageKey(dashboardName);
  const { isLoading } = useDashboard(dashboardName);
  const { totals } = useGrid(dashboardName);
  const [isOpen, setIsOpen] = useLocalStorage<OpenStatus>(
    storageKey,
    OpenStatus.false
  );

  useEffect(() => {
    dispatch(registryActions.set(storageKey, isOpen));
  }, [isOpen]);

  const toggleIsOpen = useCallback(() => {
    setIsOpen((prevIsOpen) => Number(!prevIsOpen));
  }, []);

  if (!totals || !Object.keys(totals).length) return null;

  return (
    <Button
      appearance="primary"
      onClick={toggleIsOpen}
      isLoading={!isOpen && isLoading}
      disabled={isLoading}>
      {isOpen ? 'Hide' : 'Show'} Totals
    </Button>
  );
};
